import { render, staticRenderFns } from "./SecurityView.vue?vue&type=template&id=421c193c&scoped=true"
import script from "./SecurityView.vue?vue&type=script&lang=js"
export * from "./SecurityView.vue?vue&type=script&lang=js"
import style0 from "./SecurityView.vue?vue&type=style&index=0&id=421c193c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c193c",
  null
  
)

export default component.exports